/* eslint-disable import/no-anonymous-default-export */
import axios from './BASE_API'
import AuthHeader from './AuthHeader'

// class define
class AuthAPI {
  // apply for leave
  resetPassRequest: any = (data: any) => {
    return axios.post('/user/forget-password-request', data)
  }
  // apply for leave
  resetPassword: any = (data: any) => {
    return axios.post('/user/reset-password-confirm', data)
  }
  // registration

  registerRequest: any = (data: any) => {
    return axios.post('/company/registration-request', data)
  }
  registerRequestVerify: any = (data: any) => {
    return axios.post('/company/registration-request-verify', data)
  }
  registerAction: any = (data: any) => {
    return axios.post('/company/registration', data)
  }
  // me API
  getMyProfile: any = () => {
    return axios.get('/user/me', {headers: AuthHeader()})
  }
  // change password
  changePassword: any = (data: any) => {
    return axios.post('/user/password-change', data, {headers: AuthHeader()})
  }
  // add email configuration
  addEmailConfiguration: any = (data: any) => {
    return axios.post('/configure-email/add', data, {headers: AuthHeader()})
  }
  // update email configuration
  updateEmailConfiguration: any = (data: any) => {
    return axios.put('/configure-email/update', data, {headers: AuthHeader()})
  }
  // get email configuration
  getEmailConfiguration: any = () => {
    return axios.get(`/configure-email/details`, {headers: AuthHeader()})
  }
}

export default new AuthAPI()
